// extracted by mini-css-extract-plugin
export default {"mainContainer":"VSGxvF","container":"Tjf_pC","image":"Xc1w4k","color":"mhwh7O","waitingScreenColor":"yR7L3f"};